export default __webpack_public_path__ + "static/media/location.528ab0f4.png";